import React, {useState} from "react";
import {useFormState} from "react-final-form";
import SummarySidebar from "./SummarySidebar";
import AuthTab from "../../core/components/tabs/AuthTab";
import ResetPasswordPage from "../../auth/components/ResetPasswordPage";
import {useDispatch, useSelector} from "react-redux";
import useIsMobile from "../helpers/MobileHelper";
import {previousPage, RESET_PASSWORD_LABELS} from "../actions/PageActions";

function AuthPage() {
    const showSummary = useSelector((state) => state.summary.status);
    const isMobile = useIsMobile();
    const [showResetPassword, setShowResetPassword] = useState(false);
    const resetPasswordStep = useSelector(state => state.page.resetPasswordStep);
    const {submitting} = useFormState({subscription: {submitting: true}});

    const dispatch = useDispatch();

    const onClickBack = () => {
        dispatch(previousPage());
    };

    const submitResetPasswordForm = (e) => {
        e.preventDefault();
        const form = document.getElementById('reset-password-active-form');
        if (form) {
            form.requestSubmit
                ? form.requestSubmit()
                : form.dispatchEvent(new Event('submit', {bubbles: true, cancelable: true}));
        }
    };

    return <div className="main-wrap with-single-btn_v3">
        <div className="container_v3">
            <main className="main-content">
                <div className="form-wrap">
                    <div className="form-validation">
                        <div className="form-group">
                            {showResetPassword ? (
                                <ResetPasswordPage
                                    onSignIn={() => setShowResetPassword(false)}
                                />
                            ) : (
                                <div className="auth-form">
                                    <div className="auth-form__inner">
                                        <form id={'login-form'}>
                                            <AuthTab
                                                onForgotPassword={() => setShowResetPassword(true)}
                                            />
                                        </form>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="form-group form-group-back auth-form__inner" style={{display:'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                            <div href="#" className="btn_v3 btn_v3_back btn_v3-md btn_v3-bd-bold btn_v3-default"
                                 onClick={onClickBack}>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.9223 11.507C6.84081 11.5748 6.73571 11.6076 6.6301 11.598C6.52448 11.5884 6.42701 11.5372 6.3591 11.4558L3.6927 8.25577C3.65758 8.21563 3.63084 8.16887 3.61406 8.11824C3.59728 8.06761 3.5908 8.01414 3.59499 7.96096C3.59918 7.90779 3.61396 7.856 3.63847 7.80862C3.66297 7.76125 3.6967 7.71925 3.73768 7.68511C3.77865 7.65096 3.82604 7.62536 3.87706 7.6098C3.92807 7.59424 3.98169 7.58904 4.03474 7.5945C4.0878 7.59997 4.13923 7.61599 4.186 7.64162C4.23277 7.66726 4.27394 7.70199 4.3071 7.74377L6.9735 10.9438C7.04136 11.0253 7.07409 11.1304 7.06449 11.236C7.05489 11.3416 7.00374 11.4391 6.9223 11.507Z" fill="#3C475B"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.9223 4.49265C7.00374 4.56056 7.05489 4.65804 7.06449 4.76365C7.07409 4.86926 7.04136 4.97436 6.9735 5.05585L4.3071 8.25585C4.27394 8.29763 4.23277 8.33236 4.186 8.358C4.13923 8.38363 4.0878 8.39965 4.03474 8.40512C3.98169 8.41059 3.92807 8.40539 3.87706 8.38983C3.82604 8.37427 3.77865 8.34866 3.73768 8.31452C3.6967 8.28037 3.66297 8.23837 3.63847 8.191C3.61396 8.14363 3.59918 8.09183 3.59499 8.03866C3.5908 7.98549 3.59728 7.93201 3.61406 7.88138C3.63084 7.83076 3.65758 7.78399 3.6927 7.74385L6.3591 4.54385C6.42701 4.4624 6.52448 4.41126 6.6301 4.40166C6.73571 4.39206 6.84081 4.42479 6.9223 4.49265Z" fill="#3C475B"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M4 7.99941C4 7.89333 4.04214 7.79159 4.11716 7.71657C4.19217 7.64156 4.29391 7.59941 4.4 7.59941L12 7.59941C12.1061 7.59941 12.2078 7.64156 12.2828 7.71657C12.3579 7.79159 12.4 7.89333 12.4 7.99941C12.4 8.1055 12.3579 8.20724 12.2828 8.28226C12.2078 8.35727 12.1061 8.39941 12 8.39941L4.4 8.39941C4.29391 8.39941 4.19217 8.35727 4.11716 8.28226C4.04214 8.20724 4 8.1055 4 7.99941Z" fill="#3C475B"/>
                                </svg>
                                Back
                            </div>
                            {isMobile && (
                                <div className="form-btn_v3">
                                    <button
                                        type={showResetPassword ? 'button' : 'submit'}
                                        onClick={showResetPassword ? submitResetPasswordForm : undefined}
                                        className="btn_v3 btn_v3_next btn_v3-md btn_v3-primary btn_v3-with-icon"
                                        style={{borderWidth: '2px', opacity: submitting ? 0.7 : 1, cursor: submitting ? 'wait' : 'pointer'}}
                                        disabled={submitting}
                                    >
                                        {submitting
                                            ? 'Processing...'
                                            : (showResetPassword && resetPasswordStep ? RESET_PASSWORD_LABELS[resetPasswordStep] : 'Calculate price')}
                                        <span className="btn_v3__icon">
                                            <img src="/_core/assets/themes/v5/assets/img/form3/arrow-long-right.svg" alt=""/>
                                        </span>
                                    </button>
                                </div>
                            )}
                        </div>
                        <div className={`form-bottom-panel ${showSummary ? 'active' : ''}`}>
                            {isMobile && (<SummarySidebar />)}
                        </div>
                    </div>
                </div>
                <div className="ap--m-bottom"></div>
            </main>
            {!isMobile && (<SummarySidebar />)}
        </div>
    </div>
}

export default AuthPage;